import React, { useState, useEffect } from "react";
import axios from "axios";
import { SERVER_URI } from "../utils";

function Service() {
  const [service, setService] = useState([]);
  useEffect(() => {
    axios.get(`${SERVER_URI}/service`).then((res) => {
        setService(res.data);
    });
  }, []);
    return (
            <section className="section bg-white" id="service">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="container-title text-center mb-1 pb-2">
                    <div className="titles">
                       <h2 className="title text-capitalize">What I Do?</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
{service.map((item) => 
                    <div className="col-md-6 col-sm-12 mt-4 pt-2" key={item.id}>
                        <div className="feature-widget text-left rounded" style={{minHeight: "235px"}}>
                            <div className="services-icon mb-3 text-center">
                                <img src={item.icon} alt="stack logo" width={"100px"} />
                            </div>
                            <div className="services-texts text-center">
                                <h4 className="title text-muted mb-3">{item.title}</h4>
                                <p className="text-light-muted">{item.description}</p>
                            </div>
                        </div>
                    </div>
)}
                </div>
            </div>
        </section>
    );
}

export default Service;